import { Component, OnInit } from '@angular/core';
import {UserService} from "../../services/user.service";
import {LoginComponent} from "../login/login.component";
import {User} from "../../models/user";
import {environment} from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
declare var $: any;

@Component({
  selector: 'app-codeudores',
  templateUrl: './codeudores.component.html',
  styleUrls: [
    './codeudores.component.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css',
    '../login/css/table.css',
    '../login/css/estilos.css'
  ],
  providers:[UserService]
})
export class CodeudoresComponent implements OnInit {
  public identity;
  public token;
  public codeudorasociado;
  public miscodeudorasociado
  public codeudor;
  public user: User;
  actual = environment.actual;
  public colorFondo = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;
  public codeudoresConfig 
  public mobile

  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) {
    this.user = new User(1, '', '', '', '', '', '', 0, 0);
  }

  ngOnInit() {
    this.spinner.show();
    this.identity =JSON.parse(this._userService.GetsessionStorage('identity'));
    this.codeudoresConfig = JSON.parse(this._userService.GetsessionStorage('config'));
    this.cosultarcodeudores();
    this.consoltarcodeudoresAso();

    if (window.screen.width > 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  decodeBuffer(arraybuffer?) {
    if(arraybuffer != null) {
      return String.fromCharCode.apply(null, new Uint16Array(arraybuffer));
    }
  }

  cosultarcodeudores(){
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year +'-'+ (monthIndex+1) +'-'+ day
    };
    this._userService.httpPost('codeudores', data).subscribe(
      response=>{
        if (response.status != 'error') {
          this.codeudorasociado = response.details;
        }else{
          console.log(response.details)
        } 
      },
      error=>{
        console.log(<any>error);
      }
    );
  }

  consoltarcodeudoresAso(){
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year +'-'+ (monthIndex+1) +'-'+ day
    };

    this._userService.httpPost('codeudoresAso', data).subscribe(
      response=>{
        if (response.status != 'error') {
          this.miscodeudorasociado = response.details;
        }else{
          console.log(response.details)
        } 
        this.spinner.hide();
      },
      error => {
        console.log(<any>error);
        this.spinner.hide();
      }
    )
  }

}
